import React from 'react';

export const EnterpriseTrialContent = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="w-full max-w-3xl px-8 md:px-14 lg:px-16 2xl:max-w-4xl 2xl:px-36">
    {children}
  </div>
);
